var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 18l-6-6 6-6"}));
}

ChevronLeftInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
